import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Audit, CreateAuditRequest } from '@seo/types';
import { apiPost } from '@/lib/api';

export function useCreateAudit() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateAuditRequest) => apiPost<Audit>('/v1/audits', input),
    onSuccess: (audit) => {
      void qc.invalidateQueries({ queryKey: ['audits'] });
      qc.setQueryData(['audit', audit.id], audit);
    },
  });
}
